$(document).ready(function () {

  if($('.swiper-pimp-device')) {
    
  }

  
});
function readyToManipulateDOM() {
  var swiperPimpDevice = new Swiper(".swiper-pimp-device", {
      cssMode: true,
      speed: 1000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: "auto",
      mousewheel: true,
      keyboard: true,
    });
}
document.addEventListener('DOMContentLoaded', readyToManipulateDOM );

